import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';
import { RESET_ALL_ACTION } from '../actions';

export type PreferencesState = {
  tenantIds?: string[];
};

const initialState: PreferencesState = {
  tenantIds: undefined
};

const slice = createSlice({
  name: 'preferences',
  initialState,
  extraReducers: (builder) => builder.addCase(RESET_ALL_ACTION, () => initialState),
  reducers: {
    setTenantIds: (state, { payload: tenantIds }: PayloadAction<string[] | undefined>) => {
      state.tenantIds = tenantIds;
    }
  }
});

export default slice.reducer;

export const { setTenantIds } = slice.actions;

export const getTenantIds =
  () =>
  (state: RootState): string[] | undefined =>
    state.preferences.tenantIds;
